import { useEffect, useMemo } from 'react'
import { ActionWithPayload } from '@common/utils'
import { TimePeriod } from '@common/constants'
import { BuyCheckoutActionTypes } from '@buy/state/checkout/actions'
import { BillingDetailedSubscriptionPlan } from '@common/state/billing/state'
import { BuySelectedAddon, BuyAddon } from '@buy/state/add-on'
import { BuyPlan } from '@buy/state/plan'
import { getCartInfo } from '@buy/utils'
import { useParams } from 'react-router-dom'

type ParamTypes = {
    plan: string
    pathProduct: string
}

export const useCustomizeCart = (
    state: {
        agents: number
        endpoints: number
        billingFrequency: TimePeriod
        planData: BuyPlan
        selectedPlan: BuyPlan
        extraAddonsSelected: BuyAddon[]
        accountSubscriptions?: BillingDetailedSubscriptionPlan[]
    },
    actions: {
        setSelectedAddons: (addons: BuySelectedAddon[]) => ActionWithPayload<
            BuyCheckoutActionTypes.SET_SELECTED_ADDONS,
            {
                addons: BuySelectedAddon[]
            }
        >

        setExtraAddons: (addons: BuyAddon[]) => ActionWithPayload<
            BuyCheckoutActionTypes.SET_EXTRA_ADDON,
            {
                addons: BuyAddon[]
            }
        >
    }
) => {
    const { plan: urlPlan } = useParams<ParamTypes>()
    const cart = useMemo(() => {
        return getCartInfo(
            state.agents,
            state.endpoints,
            state.billingFrequency,
            state.planData,
            state.selectedPlan,
            state.extraAddonsSelected,
            state.accountSubscriptions,
            urlPlan
        )
    }, [
        state.agents,
        state.endpoints,
        state.billingFrequency,
        state.planData,
        state.selectedPlan,
        state.extraAddonsSelected,
        state.accountSubscriptions,
        urlPlan,
    ])

    useEffect(
        () => {
            actions.setExtraAddons(cart.extraAddons)
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [state.selectedPlan, state.accountSubscriptions, actions.setExtraAddons]
    )

    useEffect(
        () => {
            actions.setSelectedAddons(cart.addons)
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [
            state.agents,
            state.endpoints,
            state.selectedPlan,
            state.extraAddonsSelected,
            state.billingFrequency,
            state.accountSubscriptions,
            actions.setSelectedAddons,
        ]
    )

    return cart
}
